
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'ConfirmationComponent',

    props: {
      modelValue: { type: Boolean, required: true },
      noCancel: { type: Boolean, default: false },
      persistent: { type: Boolean, default: false },
      confirmText: { type: String, default: '확인' },
      maxWidth: { type: Number, default: 390 },
    },

    emits: ['confirm', 'update:modelValue'],

    data() {
      return {
        inputShow: true,
      }
    },

    computed: {
      open: {
        get() {
          return this.modelValue
        },
        set(value) {
          this.$emit('update:modelValue', value)
        },
      },
    },

    watch: {
      // 다이얼로그가 "열릴 때"만 겹치는 스낵바를 숨기고 input 포커스 처리.
      // (이전엔 prop명 오타 modalValue + immediate 로, 컴포넌트가 마운트될 때마다
      //  무조건 hideSnackbar 가 호출되어 방금 띄운 에러 스낵바까지 닫아버리는 버그가 있었음)
      modelValue(value) {
        if (!value) return
        this.$store.commit('hideSnackbar')
        setTimeout(() => {
          this.$refs.confirmInput?.focus()
        }, 1)
        setTimeout(() => {
          this.inputShow = false
        }, 10)
      },
      open(value) {
        if (value && !this.persistent) {
          window.addEventListener('keydown', this.onKeydown)
        } else {
          window.removeEventListener('keydown', this.onKeydown)
        }
      },
    },

    beforeUnmount() {
      // 다이얼로그가 열린 채 컴포넌트가 unmount 될 때 keydown 리스너가 window 에 잔류하는 것을 방지
      window.removeEventListener('keydown', this.onKeydown)
    },

    methods: {
      cancel() {
        if (this.persistent) return

        // open setter 가 이미 update:modelValue 를 emit 하므로 직접 emit 은 중복(이중 emit) — 제거
        this.open = false
      },

      confirm() {
        setTimeout(() => {
          this.open = false
          this.$emit('confirm')
        }, 10)
      },

      onKeydown(e: KeyboardEvent) {
        if (e.key === 'Enter') {
          this.confirm()
        }
      },
    },
  })
